/**
 * @description 药商、药房、药品管理store入口
 * @author maruirui
 * @since 2021-01-07
 */
import pharmacy from './modules/pharmacy'

const pharmacyManagement = {
  pharmacy
}

export default pharmacyManagement



// WEBPACK FOOTER //
// ./src/pages/pharmacyManage/store/index.js